import React from "react";
import { FlexBox, Slide, Image, Notes } from "spectacle";
import firstWorldProblemsForCrashes from "../images/first_world_problems1.png";
export var UserPainSlides = function () { return (React.createElement(React.Fragment, null,
    React.createElement(Slide, { backgroundColor: "rgb(255, 255, 255)" },
        React.createElement(FlexBox, { justifyContent: "center", alignContent: "center", height: "100%" },
            React.createElement(Image, { src: firstWorldProblemsForCrashes, width: 700 })),
        React.createElement(Notes, null, "They were only doing their job. But the application was not working. Or totally time-consuming.")))); };
